import React from "react";
import { WebArea, WebRoute } from "@intech/web-ui";
import { RouteProps } from "react-router-dom";

import * as Screens from "@screens";

import { FaClipboard, FaEnvelope, FaHome, FaLock, FaMoneyCheck, FaSignOutAlt, FaSyncAlt, FaUser } from "react-icons/fa";

export const routes: Array<WebRoute | WebArea> = [

  new WebRoute({
    id: "esqueciSenha",
    path: "/esqueciSenha",
    title: "Esqueci Minha Senha",
    component: (routeProps: RouteProps) => <Screens.EsqueciSenha {...routeProps} />,
    exactPath: true,
    showInMenu: false,
  }),
  new WebRoute({
    id: "termos",
    path: "/termos",
    title: "Termos LGPD",
    component: (routeProps: RouteProps) => <Screens.Termos {...routeProps} />,
    exactPath: true,
    showInMenu: false,
  }),
  new WebRoute({
    id: "trocarSenhaPrimeiroAcesso",
    path: "/trocarSenhaPrimeiroAcesso",
    title: "Primeiro Acesso",
    component: (routeProps: RouteProps) => <Screens.TrocarSenhaPrimeiroAcesso {...routeProps} />,
    exactPath: true,
    showInMenu: false,
  }),
  new WebRoute({
    id: "home",
    path: "/",
    title: "Página Inicial",
    component: (routeProps: RouteProps) => <Screens.Home {...routeProps} />,
    icon: <FaHome />,
    exactPath: true,
    showInMenu: true
  }),
  new WebRoute({
    id: "dadosPessoais",
    path: "/dadosPessoais",
    title: "Dados Pessoais",
    component: (routeProps: RouteProps) => <Screens.DadosPessoais {...routeProps} />,
    icon: <FaUser />,
    exactPath: true,
    showInMenu: true
  }),
  // new WebRoute({
  //   id: "alteracaoCadastral",
  //   path: "/alteracaoCadastral",
  //   title: "Alteração Cadastral",
  //   component: (routeProps: RouteProps) => <Screens.AlteracaoCadastral {...routeProps} />,
  //   icon: <FaAddressCard />,
  //   exactPath: true,
  //   showInMenu: true
  // }),
  new WebRoute({
    id: "extrato",
    path: "/extrato",
    title: "Extrato de Contribuições",
    component: (routeProps: RouteProps) => <Screens.Extrato {...routeProps} />,
    icon: <FaMoneyCheck />,
    exactPath: true,
    showInMenu: true
  }),
  new WebRoute({
    id: "comprovanteRendimentos",
    path: "/comprovanteRendimentos",
    title: "Comprovante de Rendimentos",
    component: (routeProps: RouteProps) => <Screens.ComprovanteRendimentos {...routeProps} />,
    icon: <FaMoneyCheck />,
    exactPath: true,
    showInMenu: true
  }),
  new WebRoute({
    id: "comprovantes",
    title: "Comprovantes",
    icon: <FaClipboard />,
    path: "/comprovantes",
    component: (routeProps: RouteProps) => <Screens.Comprovantes.Comprovantes {...routeProps} />,
    showInMenu: true,
    exactPath: true,
  }),
  new WebRoute({
    id: "comprovantesDetalhe",
    title: "Comprovante",
    icon: <FaClipboard />,
    path: "/comprovantesDetalhe/:oid",
    linkPath: "/comprovantesDetalhe",
    component: (routeProps: RouteProps) => <Screens.Comprovantes.Detalhe {...routeProps} />,
    showInMenu: false,
    exactPath: true,
  }),
  new WebRoute({
    id: "selecionarContrato",
    path: "/selecionarContrato",
    title: "Selecionar Contrato",
    component: (routeProps: RouteProps) => <Screens.SelecionarContrato {...routeProps} />,
    icon: <FaSyncAlt />,
    exactPath: true,
    showInMenu: true
  }),
  new WebRoute({
    id: "trocarSenha",
    title: "Trocar senha",
    icon: <FaLock />,
    path: "/trocarSenha",
    component: (routeProps: RouteProps) => <Screens.TrocarSenha {...routeProps} />,
    showInMenu: false,
    tooltip: "Trocar Senha",
    tooltipPlacement: "bottom",
  }),
  new WebRoute({
    id: "relacionamento",
    title: "Fale Conosco",
    icon: <FaEnvelope />,
    path: "/relacionamento",
    component: (routeProps: RouteProps) => <Screens.Relacionamento {...routeProps} />,
    showInMenu: false,
    tooltip: "Fale Conosco",
    tooltipPlacement: "bottom",
  }),
  new WebRoute({
    id: "listarParticipantes",
    title: "Listar Participantes",
    path: "/listarParticipantes",
    component: (routeProps: RouteProps) => <Screens.ListarParticipantes {...routeProps} />,
    showInMenu: false,
  }),
  new WebRoute({
    id: "login",
    path: "/login",
    title: "Sair",
    component: (routeProps: RouteProps) => <Screens.Login {...routeProps} />,
    icon: <FaSignOutAlt />,
    exactPath: true,
    showInMenu: false,
  }),
];

export const headerRoutes: Array<WebRoute> = [
  new WebRoute({
    id: "trocarSenha",
    title: "Trocar senha",
    icon: <FaLock />,
    path: "/trocarSenha",
    component: (routeProps: RouteProps) => <Screens.TrocarSenha {...routeProps} />,
    showInMenu: false,
    tooltip: "Trocar Senha",
    tooltipPlacement: "bottom",
  }),
  new WebRoute({
    id: "relacionamento",
    title: "Fale Conosco",
    icon: <FaEnvelope />,
    path: "/relacionamento",
    component: (routeProps: RouteProps) => <Screens.Relacionamento {...routeProps} />,
    showInMenu: false,
    tooltip: "Fale Conosco",
    tooltipPlacement: "bottom",
  }),
  new WebRoute({
    id: "login",
    path: "/login",
    title: "Sair",
    component: (routeProps: RouteProps) => <Screens.Login {...routeProps} />,
    icon: <FaSignOutAlt />,
    exactPath: true,
    showInMenu: false,
    tooltip: "Sair",
    tooltipPlacement: "bottom",
  }),
];
